import api from './api';

export interface NovelVolume {
  id: string;
  novelId: string;
  title: string;
  theme: string;
  description: string;
  contentOutline: string;
  volumeNumber: number;
  chapterStart: number;
  chapterEnd: number;
  chapterCount?: number; // 章节数量（可选，用于智能章纲）
  estimatedWordCount: number;
  actualWordCount: number;
  keyEvents: string;
  characterDevelopment: string;
  plotThreads: string;
  status: 'PLANNED' | 'IN_PROGRESS' | 'COMPLETED' | 'REVISED';
  isAiGenerated: boolean;
  lastModifiedByAi: string;
  createdAt: string;
  updatedAt: string;
}
export interface VolumeGuidanceRequest {
  currentContent: string;
  userInput: string;
}
class NovelVolumeService {

  private unwrapResponse<T>(res: any): T {
    console.log('NovelVolumeService - unwrapResponse 输入:', res);
    
    // 检查是否是后端 Result 结构
    if (res && typeof res === 'object' && 'code' in res && 'data' in res) {
      console.log('NovelVolumeService - 检测到 Result 结构，提取 data:', res.data);
      return res.data as T;
    }
    
    // 如果不是 Result 结构，直接返回
    console.log('NovelVolumeService - 未检测到 Result 结构，直接返回:', res);
    return res as T;
  }

  /**
   * 生成下一步写作指导
   */
  async generateNextStepGuidance(volumeId: string, request: VolumeGuidanceRequest): Promise<any> {
    const res = await api.post(`/volumes/${volumeId}/next-guidance`, request);
    return this.unwrapResponse<any>(res);
  }

  /**
   * 获取小说的所有卷
   */
  async getVolumesByNovelId(novelId: string): Promise<NovelVolume[]> {
    const res = await api.get(`/volumes/novel/${novelId}`);
    return this.unwrapResponse<NovelVolume[]>(res);
  }

  /**
   * 获取卷详情
   */
  async getVolumeDetail(volumeId: string): Promise<any> {
    const res = await api.get(`/volumes/detail/${volumeId}`);
    return this.unwrapResponse<any>(res);
  }

  /**
   * 更新卷信息
   */
  async updateVolume(volumeId: string, data: Partial<NovelVolume>): Promise<NovelVolume> {
    const res = await api.put(`/volumes/${volumeId}`, data);
    return this.unwrapResponse<NovelVolume>(res);
  }

  /**
   * 获取状态显示文本
   */
  getStatusText(status: NovelVolume['status']): string {
    const statusMap = {
      'PLANNED': '规划中',
      'IN_PROGRESS': '进行中',
      'COMPLETED': '已完成',
      'REVISED': '已修订'
    };
    return statusMap[status] || status;
  }

  /**
   * 获取状态颜色
   */
  getStatusColor(status: NovelVolume['status']): string {
    const colorMap = {
      'PLANNED': 'orange',
      'IN_PROGRESS': 'blue',
      'COMPLETED': 'green',
      'REVISED': 'purple'
    };
    return colorMap[status] || 'default';
  }
}

export const novelVolumeService = new NovelVolumeService();
export default novelVolumeService;
